<template>
  <v-bottom-navigation
    v-model="bottomNav"
    dark
    
    app
    fixed
  >
    <v-btn @click="showBlog()">
      <span>Drops Blog</span>
      <v-icon>mdi-blogger</v-icon>
    </v-btn>

    <v-btn>
      <span @click="showFacebook()">Facebook</span>
      <v-icon>mdi-facebook</v-icon>
    </v-btn>

    <v-btn @click="showPlaylist()">
      <span>Playlist</span>
      <v-icon>mdi-playlist-music</v-icon>
    </v-btn>

<!--
    <v-btn @click="showSocials()">
      <span>Sobre</span>
      <v-icon>mdi-account-group</v-icon>
    </v-btn>
-->

    <v-btn @click="showPatrocinio()">
      <span>Patrocinio</span>
      <v-icon>mdi-account-cash</v-icon>
    </v-btn>

    <v-btn @click="showContato()">
      <span>Contato</span>
      <v-icon>mdi-email-outline</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
  export default {
    data () {
      return {
        bottomNav: 0,
      }
    },

  methods: {
    showBlog: function() {
      this.$store.commit("setIsBlogPost", true);
    },
    showFacebook: function() {
      this.$store.commit("setIsFacebook", true);
    },
    showSocials: function() {
      this.$store.commit("setIsRedesSociais", true);
    },
    showPatrocinio: function() {
      this.$store.commit("setIsPatrocinador", true);
    },
    showPlaylist: function() {
      this.$store.commit("setIsSpotify", true);
    },
    showContato: function() {
      this.$store.commit("setIsContato", true);
    },
  },


    computed: {
      color: function() {
        switch (this.bottomNav) {
          case 0: return 'blue-grey'
          case 1: return 'teal'
          case 2: return 'brown'
          default: return 'indigo'
        }
      },
    },
  }
</script>